import React from "react";
import {Box, Text} from "zmp-ui";


export const Section = ({
                           children,
                           title,
                           padding = "all",
                           ...props
                        }) => {
   return (
      <Box
         className={`relative bg-background ${
            padding === "all" ? "p-4 space-y-4" : ""
         } ${padding === "title-only" ? "py-4 space-y-4" : ""}`}
      >
         <Text.Title className={`${padding === "title-only" ? "px-4" : ""} flex items-center`}>
            {!!props?.icon && <Text className="mr-1">{props?.icon}</Text>}
            {title}
         </Text.Title>
         {!!props?.descriptions && (
            <Text className="title-descriptions" style={{marginTop: "4px"}}>
               {props.descriptions}
            </Text>
         )}
         {!!props?.iconRight && (
            <Text className="section-icon-right" onClick={props?.clickIconRight}>
               {props?.iconRight}
            </Text>
         )}
         {children}
      </Box>
   );
};
